export const constants = {
  // SERVICE_URL: "http://localhost:3000",
  SERVICE_URL: "https://loyalty.elektroimportoren.salext.net",
};
